module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primaerlogo_postale_neg.6b1662c2.png";